import ModelSerializerModulMixin from "../ModelSerializerModulMixin/ModelSerializerModulMixin.js";

// @vue/component
export default {
  name: "AstAdministrativeDaten",
  mixins: [
    ModelSerializerModulMixin,
  ],
};
